import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Grid } from '@alfa-bank/site-grid-universal';
import { Stack, stackingOrder } from '@alfa-bank/site-stack';
import { LayoutDesktop } from '@alfa-bank/site-layout/desktop';

import { YandexSearchBarBlack as YandexSearchBar } from './components/yandex-search';
import { TopMenu } from './components/top-menu';
import type { TMainHeader, IDeps } from './models';
import { MainHeader as Component } from './main-header';
import { AlfaIcon } from './components/alfa-icon';
import styles from './styles/styles.css';

// eslint-disable-next-line styler/check-styler
export const MainHeaderV3 = createWidget<IDeps, TMainHeader>({
    styles,
    Grid,
    TopMenu,
    Stack,
    stackingOrder,
    AlfaIcon,
    LayoutDesktop,
    YandexSearchBar,
})(Component);
